// extracted by mini-css-extract-plugin
export default {"wraperNavigation":"styles_wraperNavigation__loM6k","active":"styles_active__Q9sZj"};